<template>
    <div>
        <NuxtPage />
        <LazyDialogsToast ref="toast" />
    </div>
</template>

<script setup>
definePageMeta({
  layout: "client-layouts",
});

</script>

<style lang="scss" scoped>

</style>